module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-10 col-xs-offset-1 col-sm-4 col-sm-offset-4 col-lg-3 col-sm-offset-4 "
  }, [_c('div', {
    staticClass: "content-group"
  }, [_c('div', {
    staticClass: "panel-body bg-blue border-radius-top text-center",
    staticStyle: {
      "background-image": "url(/assets/img/bg.png)",
      "background-size": "contain"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-group-sm"
  }, [_c('span', {
    staticClass: "display-block"
  }, [_vm._v("Senior Software Engineer")]), _vm._v(" "), (_vm.blockOfLinks) ? _c('span', {
    staticClass: "display-block"
  }, [_vm._v("Full-stack developer")]) : _c('span', {
    staticClass: "display-block"
  }, [_vm._v("Entrepreneur")]), _vm._v(" "), _c('span', {
    staticClass: "display-block"
  }, [_vm._v("JS Enthusiast")])])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-group-sm"
  }, [_c('h5', {
    staticClass: "text-semibold no-margin-bottom"
  }, [_vm._v("\n                    Andrei Hirvi\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "display-inline-block content-group-sm",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-circle img-responsive",
    staticStyle: {
      "width": "120px",
      "height": "120px"
    },
    attrs: {
      "src": "/assets/img/me.jpg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-body no-border-top no-border-radius-top"
  }, [_c('div', {
    staticClass: "form-group mt-5"
  }, [_c('label', {
    staticClass: "text-semibold"
  }, [_vm._v("Full name:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-sm"
  }, [_vm._v("Andrei Hirvi")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "text-semibold"
  }, [_vm._v("Phone number:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-sm"
  }, [_vm._v("+372 56607807")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "text-semibold"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-sm"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("andrei.hirvi@gmail.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "text-semibold"
  }, [_vm._v("Profile web app:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-sm"
  }, [_c('a', {
    attrs: {
      "href": "http://andreihirvi.com",
      "target": "_blank"
    }
  }, [_vm._v("www.andreihirvi.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "text-semibold"
  }, [_vm._v("LinkedIN:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-sm"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/profile/view?id=143828758",
      "target": "_blank"
    }
  }, [_vm._v("My profile")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0b41fca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 369
// module chunks = 0